// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"147":"52395f6b7f0878d7","179":"51dfcbccc0140731","294":"78988d09278b6f28","890":"28b0e4817be41dea","913":"ee1e04e0df5b34ec"}[chunkId] + ".js";
};